import {
  object,
  string
} from "yup";

import "./schemas";

const nonWorkingPeriodSchema = object({
  name: string()
    .trim()
    .required(),
  description: string()
    .trim()
    .required(),
  severity: string()
    .trim()
    .required()

});

export default nonWorkingPeriodSchema;
